import { getObject, getObjectWithApiError, deleteObject, combinePaths, postObjectWithApiError, IResultAndError } from "../ChoiceApi";
import { IntakeAssignResultItem, IntakePatientInfo, IntakeOfficeCodePostRequest, IntakeDeleteRequest, IntakeSaveRequest, IntakeRefreshActive, IntakeRefreshHistoric, IntakeAppointmentDescription, IntakeResponse, IntakeLinkCreateRequest, IntakeGetOfficeCodeRequest, IntakeOfficeCodeResponse } from "../Models/IntakeModel";

const intakeTaskingURL = "api/Tasking/Intake/";
const intakeMMLURL = "api/mml/";

export async function ResetDelete(intakeResetId: number): Promise<IntakeAssignResultItem[] | undefined> {
    const fullUrl = combinePaths([intakeTaskingURL, "ResetList", intakeResetId.toString()], false);
    return await deleteObject(fullUrl);
}
export async function ResetRefresh(): Promise<IntakeAssignResultItem[] | undefined> {
    const fullUrl = combinePaths([intakeTaskingURL, "ResetList"], false);
    return await getObject(fullUrl);
}
export async function GetIntakeEdit(patientId: number, intake_assign_id?: number): Promise<IResultAndError<IntakeAppointmentDescription[] | undefined>> {
    if (!intake_assign_id) {
        const fullUrl = combinePaths([intakeTaskingURL, "Edit", patientId.toString()], false);
        return await getObjectWithApiError(fullUrl);
    }
    const fullUrl = combinePaths([intakeTaskingURL, "Edit", patientId.toString(), intake_assign_id.toString()], false);
    return await getObjectWithApiError(fullUrl);
}
export async function RefreshActiveIntakeData(patientId: number): Promise<IResultAndError<IntakeRefreshActive | undefined>> {
    const fullUrl = combinePaths([intakeTaskingURL, "RefreshActive", patientId.toString()], false);
    return await getObjectWithApiError(fullUrl);
}
export async function RefreshHistoricIntakeData(patientId: number): Promise<IResultAndError<IntakeRefreshHistoric | undefined>> {
    const fullUrl = combinePaths([intakeTaskingURL, "RefreshHistoric", patientId.toString()], false);
    return await getObjectWithApiError(fullUrl);
}
export async function SaveIntakeRequest(input: IntakeSaveRequest): Promise<IResultAndError<IntakeResponse | undefined>> {
    const fullUrl = combinePaths([intakeTaskingURL, "Save"], false);
    return await postObjectWithApiError(fullUrl, input);
}
export async function GetOfficeCode(input: IntakeGetOfficeCodeRequest): Promise<IResultAndError<IntakeOfficeCodeResponse | undefined>> {
    const fullUrl = combinePaths([intakeTaskingURL, "GetOfficeCode"], false);
    return await postObjectWithApiError(fullUrl, input);
}
export async function PostOfficeCode(input: IntakeOfficeCodePostRequest): Promise<IResultAndError<IntakeResponse | undefined>> {
    const fullUrl = combinePaths([intakeMMLURL, "IntakeOfficeCode"], false);
    return await postObjectWithApiError(fullUrl, input);
}
export async function DeleteIntakeRequest(input: IntakeDeleteRequest): Promise<IResultAndError<IntakeResponse | undefined>> {
    const fullUrl = combinePaths([intakeMMLURL, "IntakeAssignDelete"], false);
    return await postObjectWithApiError(fullUrl, input);
}
export async function CreateIntakeLink(input: IntakeLinkCreateRequest): Promise<IResultAndError<IntakeResponse | undefined>> {
    const fullUrl = combinePaths([intakeMMLURL, "IntakeLinkCreate"], false);
    return await postObjectWithApiError(fullUrl, input);
}